import { Modal, CircularProgress } from "@mui/material";
import "../css/AcceptDisputeModal.css";

const AcceptDisputeModal = ({
  isOpen,
  onClose,
  onDelete,
  message,
  isLoading = false,
  disputeData = null,
}) => {
  // Check if this is a success message (contains "accepted")
  const isSuccessMessage = message && message.toLowerCase().includes("accepted");
  
  // Determine if it's BMS or Airline acceptance based on message
  const isBMSAcceptance = message && message.toLowerCase().includes("bms");
  
  // Get dynamic data based on acceptance type
  const getSuccessData = () => {
    if (!disputeData) return { bmsCount: 0, exempted: 0, billableCount: 0 };
    
    if (isBMSAcceptance) {
      const bmsCount = disputeData.scannedPassengerCount || 0;
      const exempted = disputeData.exemptedPassengerCount || 0;
      const billableCount = bmsCount - exempted;
      return { bmsCount, exempted, billableCount };
    } else {
      const bmsCount = disputeData.airlinePassengerCount || 0;
      const exempted = disputeData.airlineExemptedPassengerCount || 0;
      const billableCount = bmsCount - exempted;
      return { bmsCount, exempted, billableCount };
    }
  };
  
  const successData = getSuccessData();
  const title = isBMSAcceptance 
    ? "You have accepted BMS Passenger Count"
    : "You have accepted Airline Passenger Count";
  const countLabel = isBMSAcceptance ? "BMS Count:" : "Airline Count:";
  
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="accept-dispute-modal-content">
        {isSuccessMessage ? (
          <>
            <div className="success-modal-title">
              {title}
            </div>
            <div className="success-modal-details">
              <div className="count-detail">
                <span className="count-label">{countLabel}</span>
                <span className="count-value">{successData.bmsCount}</span>
              </div>
              <div className="count-detail">
                <span className="count-label">Exempted:</span>
                <span className="count-value">{successData.exempted}</span>
              </div>
              <div className="count-detail">
                <span className="count-label">Billable Count:</span>
                <span className="count-value">{successData.billableCount}</span>
              </div>
            </div>
            <button
              className="success-modal-done-button"
              onClick={onClose}
            >
              Done
            </button>
          </>
        ) : (
          <>
            <div style={{ marginBottom: "20px", lineHeight: "1.5" }}>{message}</div>
            <div>
              <button
                className="accept-dispute-modal-delete-button"
                onClick={isLoading ? null : onDelete}
              >
                Yes 
                {isLoading && <CircularProgress size={16} color="inherit" />}
              </button>
              <button
                className="accept-dispute-modal-cancel-button"
                onClick={isLoading ? null : onClose}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
export default AcceptDisputeModal;
